import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import api from "./api";
import { ArrowDown } from 'react-feather';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Helmet } from 'react-helmet-async';

export default function ReceiptPage() {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { created_at, order_id } = useParams();
  const [loading, setLoading] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const printRef = useRef();

  useEffect(() => {
    async function fetchReceipt() {
      try {
        const res = await api.get(`${baseUrl}/receipt/${created_at}/${order_id}/`);
        setReceiptData(res.data);
      } catch (err) {
        console.error(err);
      }
    }
    fetchReceipt();
  }, [created_at, order_id]);

  if (!receiptData) return <p className="text-center">Loading receipt...</p>;

  const {
    vendor_username, vendor_loc, vendor_mobile,
    order_id_long, order_id_short, date, status,
    payment_status, cust_name, cust_phone, delivery_loc,
    delivery_fee, total, products, currency, year
  } = receiptData;

  const formatCurrency = (value) =>
    `${currency} ${new Intl.NumberFormat().format(value)}`;

    const handleDownloadPDF0 = () => {
        setLoading(true);
        const input = printRef.current;
        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF({
                orientation: "portrait",
                unit: "pt",
                format: [canvas.width, canvas.height]
            });

            pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
            pdf.save(`Receipt_${order_id_long}.pdf`);
            setLoading(false);
        });
    };

  return (
    <>
      <Helmet>
          <title>Receipt</title>
          <meta name="description" content={`Receipt`} />
      </Helmet>
      <main className="normal-mt-sctn bgdashmainreceipt">
          <div className='receiptvw_con'>        
              <div className="col-12">
                  <div ref={printRef} style={{
                      padding: "20px",
                      backgroundColor: "white",
                      color: "black",
                      fontFamily: "'Courier New', monospace",
                      width: "400px",
                      margin: "0 auto",
                      display: "block"
                  }}>
                      <div className="text-center mb-3">
                      <h5 style={{ margin: 0 }}>{vendor_username}</h5>
                      <small className="tcone">{vendor_loc}</small><br />
                      <small>{vendor_mobile}</small><br />
                      <small className="font7">{order_id_long}</small>
                      </div>

                      <hr />
                      <div>
                      <div><b>RECEIPT #: </b>{order_id_short}</div>
                      <div><b>DATE: </b>{date}</div>
                      <div><b>STATUS: </b>{status}</div>
                      <div><b>PAYMENT: </b>{payment_status}</div>
                      </div>

                      <hr />
                      <div>
                      <b>BILLED TO:</b><br />
                      <div>{cust_name}</div>
                      <div>{cust_phone}</div>
                      <div>{delivery_loc}</div>
                      </div>

                      <hr />
                      <table style={{ width: "100%", fontSize: "14px" }}>
                      <thead>
                          <tr>
                          <th>#</th>
                          <th>Description</th>
                          <th className="text-end">Qty</th>
                          <th className="text-end">Price</th>
                          </tr>
                      </thead>
                      <tbody>
                          {products.map((item, index) => (
                          <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.title}</td>
                              <td className="text-end">{item.qty}</td>
                              <td className="text-end">{formatCurrency(item.price)}</td>
                          </tr>
                          ))}
                          <tr>
                          <td colSpan="3" className="text-end"><b>Delivery Fee:</b></td>
                          <td className="text-end">{formatCurrency(delivery_fee)}</td>
                          </tr>
                          <tr>
                          <td colSpan="3" className="text-end"><b>Total:</b></td>
                          <td className="text-end"><b>{formatCurrency(total)}</b></td>
                          </tr>
                      </tbody>
                      </table>

                      <hr />
                      <div className="text-center">
                      <small>Thank you for shopping with us!</small><br />
                      <small>{vendor_username} © {year}</small>
                      </div>
                  </div>
                  
                  
                  <div className='col-12 text-center mt-6 mb-4' id='receipt'>                                
                      <button className="btn text-white bg-dark f85"  onClick={handleDownloadPDF0}><ArrowDown className="topheadersvg"/> <span>{loading === true ? <>Loading...</> : <>Download Receipt</>}</span></button>
                  </div>
              </div>
          </div>
      </main>
    </>
  );
}
